// extracted by mini-css-extract-plugin
export default {"scope":"lNIKH"};